<template lang='pug'>
  .fpui-input-tags(:class='color')
    .row
      .fpui-input-label-container.vcenter(:class='sizeLabel', v-if='label')
        span {{ label | translate }}
        .required-container(v-if='required')
          i.fpui.fpui-required
        fpui-helper(v-if='helper', :text="helper | translate")
      .fpui-input-text-content.vcenter(:class='inputClass')
        vue-tags-input(
          ref='input'
          v-model="model"
          :tags='tags'
          :placeholder="placeholder"
          @tags-changed="tagsChanged"
          :disabled='disabled'
          :autocomplete-items="autocomplete"
        )
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  components: { VueTagsInput },
  props: {
    value: { type: Array },
    color: { type: String, default: 'blue' },
    placeholder: { type: String },
    disabled: { type: Boolean, default: false },
    id: { type: String, required: false, default: '' },
    name: { type: String },
    error: { type: Boolean, default: false },
    autocomplete: { type: Array },
    type: { type: String, default: 'text' },
    autofocus: { type: Boolean, default: false },
    label: { type: String },
    labelSize: { type: Number, default: 3 },
    withPadding: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    helper: { type: String }
  },
  data () {
    return {
      model: ''
    }
  },
  computed: {
    tags () {
      return this.value.map(tag => ({
        tiClasses: ['valid'],
        text: tag
      }))
    },
    inputClass () {
      let className = []
      let size = 12
      if (this.label) size -= this.labelSize
      className.push(`col-xs-${size}`)
      if (this.withPadding) className.push('with-padding')
      return className.join(' ')
    },
    sizeLabel () { return `col-xs-${this.labelSize}` }
  },
  methods: {
    tagsChanged (val) {
      let tags = [...this.value]
      tags.splice(0, tags.length)
      val.forEach(v => tags.push(v.text))
      this.$emit('input', tags)
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

.fpui-input-tags {
  min-height: 35px;
  .fpui-input-label-container {
    padding-left: 0;
    cursor: pointer;
    .required-container {
      display: inline-block;
      margin-right: 7px;
      margin-top: -10px;
      width: 15px;
      vertical-align: middle;
      font-size: 22px;
      text-align: center;
      color: @blue;
      border-radius: 50%;
    }
  }
  .fpui-input-text-content:not(.with-padding) {
    padding: 0;
  }
  .vue-tags-input {
    height: 35px;
    width:100%;
    max-width:none!important;
    .input {
      border-radius: 2px;
      padding:2px;
      height: 35px;
      overflow-y: hidden;
    }
    font-size:14px;
    .tags {
      padding-left: 9px;
      flex-wrap: nowrap;
      .content {
        padding:2px;
      }
    }
  }
  .ti-tag.ti-deletion-mark, .ti-tag.ti-invalid {
    background-color: @red !important;
  }
  &.blue {
    .tag, .ti-tag {
      background-color: @blue;
    }
  }
  &.red {
    .tag, .ti-tag {
      background-color: @red;
    }
  }
  &.green {
    .tag, .ti-tag {
      background-color: @green;
    }
  }
  &.yellow {
    .tag, .ti-tag {
      background-color: @yellow;
    }
  }
}
</style>
